module.exports = __webpack_public_path__ + "img/go-search.78b9b82c.svg";